import { render, staticRenderFns } from "./taggingPopover.vue?vue&type=template&id=5b184774&"
import script from "./taggingPopover.vue?vue&type=script&lang=js&"
export * from "./taggingPopover.vue?vue&type=script&lang=js&"
import style0 from "./taggingPopover.vue?vue&type=style&index=0&id=5b184774&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports